import CalendarIcon from "assets/images/Calendar";
import ClockIcon from "assets/images/Clock";
import {google, ics, CalendarEvent} from "calendar-link";
import classNames from "classnames";
import {format} from "date-fns";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {appointmentConfirmationModal as strings} from "strings";

import Button from "components/Button";
import Divider from "components/Divider";
import PageTitle from "components/PageTitle";
import StyledModal from "components/StyledModal";

import {AppointmentCampaign} from "liberty-core/api/models";

import {outlookLink} from "lib/calendar";

import styles from "./AppointmentConfirmationModal.module.css";

type Props = {
  visible: boolean;
  onClickClose: () => void;
  startDateTime: string;
  succeessMessage: string;
  campaignName: string;
  pharmacyName: string;
  additionalApptCampaigns?: AppointmentCampaign[];
  selectedPatientId?: string;
};

export default function AppointmentConfirmationModal(props: Props) {
  const navigate = useNavigate();

  const [showCalendarOptions, setShowCalendarOptions] = useState(false);

  const calendarEvent: CalendarEvent = {
    title: props.campaignName,
    start: props.startDateTime,
    duration: [1, "hour"],
    location: props.pharmacyName,
  };

  return (
    <StyledModal visible={props.visible} className={styles.styledModal}>
      <div className={styles.modalContent}>
        <PageTitle className={styles.pageTitle}>{strings.title}</PageTitle>
        <div className={styles.description}>{props.succeessMessage}</div>
        <Divider className={styles.divider} />
        <div className={styles.row}>
          <div className={styles.padding}>
            <CalendarIcon />
          </div>
          <p className={classNames(styles.bold16, styles.label)}>
            {strings.date}
          </p>
          <p className={styles.regular16}>
            {props.startDateTime &&
              format(new Date(props.startDateTime), "MM/dd/yy")}
          </p>
        </div>
        <Divider className={styles.divider} />
        <div className={styles.row}>
          <div className={styles.padding}>
            <ClockIcon />
          </div>
          <p className={classNames(styles.bold16, styles.label)}>
            {strings.time}
          </p>
          <p className={styles.regular16}>
            {props.startDateTime &&
              format(new Date(props.startDateTime), "hh:mm aaa")}
          </p>
        </div>
        <Divider className={styles.divider} />
        <Button
          disabled={showCalendarOptions}
          onClick={() => setShowCalendarOptions(true)}
        >
          {strings.addToCalendar}
        </Button>
        {showCalendarOptions ? (
          <>
            <Button
              href={google(calendarEvent)}
              className={styles.calendarButton}
              variant="unfilled"
              target="_blank"
              rel="noopener noreferrer"
            >
              {strings.addToGoogleCalendar}
            </Button>
            <Button
              href={outlookLink(
                props.startDateTime,
                props.campaignName,
                props.pharmacyName,
              )}
              className={styles.calendarButton}
              variant="unfilled"
              target="_blank"
              rel="noopener noreferrer"
            >
              {strings.addToOutlookCalendar}
            </Button>
            <Button
              href={ics(calendarEvent)}
              className={styles.calendarButton}
              variant="unfilled"
            >
              {strings.addToICalCalendar}
            </Button>
          </>
        ) : null}
        {props.additionalApptCampaigns &&
          props.additionalApptCampaigns.length > 0 &&
          props.selectedPatientId && (
            <Button
              className={styles.continueButton}
              variant="unfilled"
              onClick={() => {
                navigate("/appointments/select-campaign", {
                  state: {
                    appointmentType: "Vaccination",
                    selectedPatientId: props.selectedPatientId,
                    apptCampaigns: props.additionalApptCampaigns,
                    startDateTime: props.startDateTime,
                  },
                });
              }}
            >
              {strings.addVaccine}
            </Button>
          )}
        <Button className={styles.continueButton} onClick={props.onClickClose}>
          {strings.continue}
        </Button>
      </div>
    </StyledModal>
  );
}
